export enum ListAlertType {
  Default = '',
  Added = 'added',
  Updated = 'updated',
  Removed = 'removed',
  ChangeTo = 'changeTo',
  LicenseTypeChange = 'licenseTypeChange',
  StateChange = 'stateChange',
  BoardCertTypeChange = 'boardCertTypeChange',
  InsuranceCoverageTypeChange = 'insuranceCoverageTypeChange',
  EducationSchoolNameChange = 'educationSchoolNameChange',
  AddNewSection = 'addNewSection',
  ChangeNewSection = 'changeToNewSection',
  SpecialtyChange = 'specialtyChange'
}
